module.exports = __webpack_public_path__ + "img/logo-bfm-tv.png";